import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import AppHeader from '../../components/AppHeader';
import Sidebar from '../../components/Sidebar';
import Transitions from '../../components/Transition';
import { useAppContext } from '../../contexts/auth';
import WorkplaceForm from './components/WorkplaceForm';

export default function EditWorkplace() {
  const { selectedCompany } = useAppContext();
  const companyCode = selectedCompany.value;

  const navigate = useNavigate();

  useEffect(() => {
    if (!companyCode) {
      toast.warn('Não foi identificada nenhuma empresa selecionada, e nessa tela é obrigatória a seleção de uma empresa. Portanto, você será redirecionado para a Home');
      navigate('/');
    }
  }, [companyCode, navigate]);

  return (
    <>
      <AppHeader isCompanySelectedDisabled />
      <Sidebar active="Workplaces" />
      <Transitions>
        <WorkplaceForm edit/>
      </Transitions>
    </>
  );
}
